import LandingBannerContainer from 'components/LandingBanner/LandingBannerContainer'
import LandingBannerData from 'components/LandingBanner/LandingBannerData'
import LandingBannerPresentation from 'components/LandingBanner/LandingBannerPresentation'

export default {
  Container: LandingBannerContainer,
  Data: LandingBannerData,
  Presentation: LandingBannerPresentation,
}
